import type { IPolicy } from '@adornis/abac/core/types.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import type { MartinusAbacPayload } from '../abac-payloads/MartinusAbacPayload.js';
import { hasRoles } from '../api/hasRoles.js';
import { Role } from '../roles.js';

export const AdminPolicy: IPolicy<MartinusAbacPayload> = {
  name: 'UserListPolicy',
  async evaluate(request) {
    if (!request.payload.currentUser) {
      return { allowed: false, reason: 'User is not logged in' };
    }
    if (hasRoles({ user: request.payload.currentUser, roles: [Role.ADMIN], contexts: [GLOBAL_CONTEXT] })) {
      return { allowed: true, reason: 'User is admin' };
    }
    return { allowed: false, reason: 'User is not admin' };
  },
};
